import { FactoryProvider } from '@angular/core';
import { NAVIGATOR } from './navigator.token';

export function navigatorFactory(): Navigator {
  return typeof navigator !== 'undefined' ? navigator : ({} as Navigator);
}

export const NAVIGATOR_PROVIDER: FactoryProvider = {
  provide: NAVIGATOR,
  useFactory: navigatorFactory,
};
